<scaffold-dialog
  [title]="data.title"
  [fit]="fit"
  [size]="data.size"
  [showCloseButton]="true"
  (close)="handleClose()"
  [minWidth]="minWidth"
>
  <div scaffoldDialogBody>
    <p>{{ data.message }}</p>

    <div *ngIf="data.toMatchValue">
      <p class="confirm-dialog-challenge-text" *ngIf="data?.toMatchMessage">
        {{ data.toMatchMessage }}
      </p>

      <div class="confirm-dialog-challenge-input-wrapper">
        <input
          class="confirm-dialog-challenge-input"
          [placeholder]="data?.toMatchValue"
          pInputText
          *ngIf="toMatchInput"
          [formControl]="toMatchInput"
        />
      </div>
      <div class="confirm-dialog-challenge-error-wrapper">
        <div class="confirm-dialog-challenge-error-container">
          <i
            style="padding-top: 2px"
            *ngIf="
              toMatchInput.dirty && data.toMatchErrorMessage && !isMatching
            "
            class="input-error-color fa-solid fa-triangle-exclamation"
          ></i>
          <p
            class="input-error-color confirm-dialog-challenge-error-content"
            *ngIf="
              toMatchInput.dirty && data.toMatchErrorMessage && !isMatching
            "
          >
            {{ data.toMatchErrorMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <app-button
      [style.visibility]="data?.avoidDeclineButton ? 'hidden' : 'visible'"
      status="secondary"
      (click)="onNoClick()"
    >
      {{ data.declineMessage || "no" | translation }}
    </app-button>
    <app-button
      [disabled]="
        data.toMatchValue && data.toMatchValue !== toMatchInput?.value
      "
      status="primary"
      cdkFocusInitial
      (click)="onYesClick()"
    >
      {{ data.confirmMessage || "yes" | translation }}
    </app-button>
  </div>
</scaffold-dialog>
